import { useState, useEffect } from "react";

/**
 * Custom hook to detect device type (iOS, Android, Mobile)
 * Handles modern iPadOS detection and PWA standalone mode
 * 
 * @returns {Object} Device detection object with isMobile, isIOS, isAndroid, isStandalone
 */
export default function useDevice() {
  const [device, setDevice] = useState({
    isMobile: false,
    isIOS: false,
    isAndroid: false,
    isStandalone: false,
  });

  useEffect(() => {
    const detectDevice = () => {
      const ua = navigator.userAgent;
      const platform = navigator.platform?.toLowerCase() || '';

      // iOS Detection (handles modern iPadOS 13+)
      // Modern iPads report as "MacIntel" but have touch support
      const isIPad = 
        /iPad/i.test(ua) || 
        (platform === 'macintel' && navigator.maxTouchPoints > 1);
      
      const isIPhone = /iPhone/i.test(ua);
      const isIPod = /iPod/i.test(ua);
      const isIOS = isIPad || isIPhone || isIPod;

      // Android Detection
      const isAndroid = /Android/i.test(ua);

      // PWA Standalone mode detection had an issue with this one 
      const isStandalone = 
        window.navigator.standalone === true || // iOS
        window.matchMedia('(display-mode: standalone)').matches; // Android/Chrome

      setDevice({
        isMobile: isIOS || isAndroid,
        isIOS,
        isAndroid,
        isStandalone,
      });
    };

    detectDevice();

    
  }, []);

  return device;
}
